import { createContext, Dispatch, SetStateAction } from 'react';
import { UserProfile } from '../services/profile';

export const UserProfileContext = createContext<
  [UserProfile | null, Dispatch<SetStateAction<UserProfile | null>>]
>([
  null,
  () => {
    /* this is default function for context */
  },
]);
